import React from 'react';

export const ShopSelector = props => {
    let { shops, currentShop, showShopProducts } = props;
    /** Return a list of buttons */
    const ShopSelectorButtons = () => (shops.length > 0) ? shops.map(
        (shop, index) => <div className="col" key={index}>
            <button
                onClick={() => showShopProducts(shop)}
                role="button"
                id={shop.uuid}
                className={`btn btn-block btn-primary w-100 d-block text-truncate ${(shop.uuid === currentShop.uuid) ? "active" : ''}`}>{shop.usual_name}</button>
        </div>
    ) : null;
    /** When we change the status of a shop, we got to find the corresponding one */
    const onShopChange = (el) => {
        let t = shops.find((e) => e.uuid === el.target.value);
        showShopProducts(t);
    }
    /** return a list of the available shops */
    const SelectShopInput = () => (shops.length > 0) ? <div className="form-group d-md-none">
        <select value={currentShop.uuid} className="form-control" onChange={e => onShopChange(e)}>
            {
                shops.map(
                    (shop, index) => <option value={shop.uuid} key={index}>{shop.usual_name}</option>
                )
            }
        </select>
    </div> : null;
    return <div className="shopSelector">
        <SelectShopInput />
        <div className="row form-group d-none d-md-flex">
            {shops.data}
            <ShopSelectorButtons />
        </div>
    </div>
}